module.exports = __webpack_public_path__ + "static/media/6.a08b5620.jpg";